import React from 'react';
import logoMusica from '../../assets/img/MUSICA ICIAR.jpeg';
import { Objetive } from './Components/Objetive';
import { CardToInstitutes } from "./Components/CardToInstitutes";
import { CardQuote } from '../../components/CardQuote';
import { Flow } from '../../workflows/Flow';
import { nodes, edges } from './matterFlow';

export function MusicInsitute() {
  return (
    <div className="container-fluid bg-light min-vh-100 pb-5">
      {/* --- Encabezado --- */}
      <header className="container py-5 text-center">
        <div className="mb-4">
          <img 
            src={logoMusica} 
            alt='Logo Música ICIAR' 
            className="img-fluid rounded-circle shadow-sm"
            style={{ maxWidth: '180px', border: '3px solid #6f42c1' }} 
          />
        </div>
        <h1 className="display-4 fw-bold text-uppercase mb-2" style={{ color: '#6f42c1' }}>
          Instituto de Música
        </h1>
        <p className="text-muted fw-bold">"Aquiles Mireles Perales"</p>
        <hr className="w-25 mx-auto border-purple border-2 opacity-75" style={{ borderColor: '#6f42c1' }} />
      </header>

      <main className="container">
        {/* --- Introducción Inspiracional --- */}
        <section className="row justify-content-center mb-5">
          <div className="col-lg-10 text-center">
            <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm border-top border-5" style={{ borderTopColor: '#6f42c1' }}>
              <p className="lead fs-4 fst-italic text-secondary">
                "Al evangelio superior que profesamos, debe corresponder una música superior."
              </p>
              <div className="row mt-4 text-start fs-6 text-muted lh-lg">
                <div className="col-md-6">
                  <p>El ministerio de la música es clave para el crecimiento del creyente; nos eleva a la presencia de Dios y sublima el alma. Es un medio poderoso para transmitir esperanza, amor y fortaleza.</p>
                </div>
                <div className="col-md-6">
                  <p>Capacitamos a quienes tienen el llamado para ser ministros de música, para que interpreten y compongan himnos inspirados que glorifiquen al gran Dios Trino.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- Quiénes Somos y Objetivo --- */}
        <section className="row g-4 mb-5">
          <div className="col-lg-6">
            <div className="bg-white p-4 rounded-4 shadow-sm h-100 border-start border-5" style={{ borderLeftColor: '#6f42c1' }}>
              <h3 className="h4 fw-bold mb-3">¿Quiénes somos?</h3>
              <p className="text-secondary">
                Somos la institución encargada de formar a los adoradores de la <strong>ICIAR</strong>. 
                Buscamos la excelencia técnica y espiritual en cada nota interpretada para la edificación de la Iglesia.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="text-white p-4 rounded-4 shadow-sm h-100 d-flex align-items-center shadow" style={{ backgroundColor: '#6f42c1' }}>
              <Objetive objetive_info={'Capacitar ministros de música para que interpreten inspiradamente composiciones cristianas a través de instrumentos y la voz, glorificando a Dios.'}/>
            </div>
          </div>
        </section>

        {/* --- Visión --- */}
        <section className="row justify-content-center g-4 mb-5">
          <div className="col-md-4">
            <CardToInstitutes title={'Visión'} info={"México y las Naciones para Cristo a través de la alabanza."}/>
          </div>
        </section>

        {/* --- Labor del Instituto (Organizada) --- */}
        <section className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
              <div className="card-header bg-dark text-white p-3">
                <h4 className="mb-0 h5"><i className="bi bi-music-note-list me-2"></i>Nuestra Labor Ministerial</h4>
              </div>
              <div className="card-body bg-white p-4">
                <div className="row">
                  <div className="col-md-6">
                    <ul className="list-group list-group-flush small">
                      <li className="list-group-item border-0">🎵 Formar y certificar ministros de música y docentes.</li>
                      <li className="list-group-item border-0">🎵 Adiestramiento en ejecución instrumental y dirección coral.</li>
                      <li className="list-group-item border-0">🎵 Establecer principios bíblicos y pedagógicos de enseñanza.</li>
                      <li className="list-group-item border-0">🎵 Colaborar con otros Institutos de la Secretaría de Educación.</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-group list-group-flush small">
                      <li className="list-group-item border-0">🎵 Investigación de música sacra y actualización del Himnario.</li>
                      <li className="list-group-item border-0">🎵 Desarrollo del orden cultual en coordinación con la Comisión General.</li>
                      <li className="list-group-item border-0">🎵 Promover planteles musicales en todos los Presbiterios.</li>
                      <li className="list-group-item border-0">🎵 Apoyo doctrinal del Instituto Teológico San Pablo.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- Llamado --- */}
        <section className="mb-5">
          <div className="card border-0 rounded-5 overflow-hidden shadow-lg text-white">
            <div style={{
              background: 'linear-gradient(135deg, #6f42c1 0%, #4b2ab2 100%)',
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1
            }}></div>
            <div className="card-body p-5 text-center position-relative" style={{ zIndex: 2 }}>
              <h3 className="fw-bold mb-3">¿Tienes el don de la música?</h3>
              <p className="lead mb-4 mx-auto" style={{ maxWidth: '800px' }}>
                "Canten al Señor un cántico nuevo; canten al Señor, toda la tierra. Canten al Señor, bendigan su nombre; proclamen día tras día su victoria."
              </p>
              <span className="badge bg-white text-dark px-3 py-2 shadow-sm">Salmos 96:1-2</span>
            </div>
          </div>
        </section>

        {/* --- Testimoniales (Ajustados) --- */}
        <section className="mb-5">
          <h3 className='text-center text-uppercase fw-bold mb-4' style={{ color: '#6f42c1' }}>Testimonios</h3>
          <div className='row g-4'>
            <div className='col-md-6'>
              <CardQuote 
                person={"Jaziel Isai"} 
                text="Llegué con conocimientos básicos de mi instrumento, pero en el Instituto encontré la técnica y la disciplina espiritual para entender que la música no es solo arte, es un ministerio." 
              />
            </div>
            <div className='col-md-6'>
              <CardQuote 
                person={"Norma Adareli"} 
                text="La formación integral me ayudó a dirigir el coro de mi congregación con orden y unción. Los maestros nos enseñan a amar el Himnario y la sana doctrina." 
              />
            </div>
          </div>
        </section>

        {/* --- Mapa Curricular --- */}
        <section className="mb-5 p-4 bg-white rounded-4 shadow-sm text-center">
          <h2 className='h4 fw-bold mb-4 text-uppercase' style={{ color: '#6f42c1' }}>Materias Musicales y Teológicas</h2>
          <div className="border rounded-3 overflow-hidden bg-light">
            <Flow 
              initialEdge={edges}
              initialNode={nodes}
              styleFlow={{ height: '30rem' }}
              disablePanOnDrag={false}
              disableZoomOnScroll={false} 
              disablePanOnScroll={true}
            />
          </div>
        </section>
      </main>
    </div>
  );
}